export const UI_TABLE_ACTIONS_CELL_CLASS = 'UiTableActionsCell w-full text-right'

export const UI_TABLE_ROW_ACTION_BUTTON_BASE_CLASS =
    'UiTableRowActionButton rounded-md px-2 py-1.5 border active:bg-opacity-80 focus:bg-opacity-80 hover:bg-opacity-90 text-white flex w-full md:w-auto items-center text-center justify-center leading-6 font-bold cursor-pointer'

export const UI_TABLE_ROW_ACTION_BUTTON_VARIANT_CLASS = {
    edit: 'UiTableRowActionButton--edit border-blue-500 bg-blue-500',
    delete: 'UiTableRowActionButton--delete border-red-500 bg-red-500',
    duplicate: 'UiTableRowActionButton--duplicate border-amber-500 bg-amber-500',
} as const

export const UI_TABLE_ROW_ACTION_BUTTON_ICON_CLASS = 'UiTableRowActionButton__Icon w-4 h-4 flex-none'

export const UI_TABLE_LEAD_INFO_CONTAINER_CLASS = 'UiTableLeadInfo flex flex-col gap-0.5 min-w-0'
export const UI_TABLE_LEAD_INFO_ICON_CLASS = 'UiTableLeadInfo__Icon size-3.5 text-gray-400 shrink-0'
export const UI_TABLE_LEAD_INFO_TEXT_CLASS =
    'UiTableLeadInfo__Text break-words whitespace-normal leading-tight text-xs'
export const UI_TABLE_LEAD_INFO_PHONE_TEXT_CLASS =
    'UiTableLeadInfo__Text UiTableLeadInfo__Text--phone break-words whitespace-normal leading-tight text-xs text-black dark:text-white'